const troubleshootingPath = "/troubleshooting"

export { troubleshootingPath }
